export default "__VITE_ASSET__BpppAJMX__"